/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExclusionTermCreatedByUser
 */
export interface ExclusionTermCreatedByUser {
    /**
     * 
     * @type {string}
     * @memberof ExclusionTermCreatedByUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExclusionTermCreatedByUser
     */
    last_name?: string;
}

/**
 * Check if a given object implements the ExclusionTermCreatedByUser interface.
 */
export function instanceOfExclusionTermCreatedByUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExclusionTermCreatedByUserFromJSON(json: any): ExclusionTermCreatedByUser {
    return ExclusionTermCreatedByUserFromJSONTyped(json, false);
}

export function ExclusionTermCreatedByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExclusionTermCreatedByUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
    };
}

export function ExclusionTermCreatedByUserToJSON(value?: ExclusionTermCreatedByUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

